<template>
  <a-modal
    title="提交作品"
    :width="600"
    :maskClosable="false"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="visible = false"
  >
    <a-form :form="form" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
      <a-form-item label="作品名称">
        <a-input v-decorator="['workName', validatorRules.workName]"></a-input>
      </a-form-item>
      <a-form-item label="简介">
        <a-textarea
          v-decorator="['workDesc', validatorRules.workDesc]"
        ></a-textarea>
      </a-form-item>
      <a-form-item label="承诺书" v-if="eventInfo.agreeTemplate">
        <j-upload
          v-decorator="['agreeFile', validatorRules.agreeFile]"
          :uploadTarget="'qiniu'"
          :fileType="'image'"
          :number="1"
          :minFileSize="100"
          :maxFileSize="2"
          :trigger-change="true"
        ></j-upload>
        <p>
          下载承诺书范本，打印后签名保存为jpg格式在此上传，图片限制2MB以内。
        </p>
        <a :href="eventInfo.agreeTemplate_url" target="_blank"
          ><a-icon type="cloud-download" /> 承诺书范本下载</a
        >
      </a-form-item>
      <a-form-item label="程序文件">
        <j-upload
          v-decorator="['workFile', validatorRules.workFile]"
          :uploadTarget="'qiniu'"
          :number="1"
          text="点击上传文件"
          :maxFileSize="eventInfo.workSize ? eventInfo.workSize : 100"
          :trigger-change="true"
        ></j-upload>
      </a-form-item>
      <a-form-item label="视频文件">
        <j-upload
          v-decorator="['videoFile', validatorRules.videoFile]"
          :uploadTarget="'qiniu'"
          :number="1"
          text="点击上传视频"
          :maxFileSize="eventInfo.workSize ? eventInfo.workSize : 100"
          :trigger-change="true"
        ></j-upload>
      </a-form-item>
      <a-form-item label="附件">
        <j-upload
          v-decorator="['zipFile', validatorRules.zipFile]"
          :uploadTarget="'qiniu'"
          :number="2"
          text="点击上传附件"
          :maxFileSize="eventInfo.workSize ? eventInfo.workSize : 100"
          :trigger-change="true"
        ></j-upload>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { httpAction, getAction, postAction } from "@/api/manage";
import JUpload from "@/components/jeecg/JUpload";
import pick from "lodash.pick";
export default {
  name: "SubmitWorkModal",
  components: {
    JUpload,
  },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      model: {},
      eventInfo: {},
      validatorRules: {
        workName: {
          rules: [{ required: true, message: "请输入作品名称!" }],
        },
        workDesc: {},
        agreeFile: {
          rules: [
            { required: false, message: "请上传承诺书! 100KB-1MB的JPG图片" },
          ],
        },
        workFile: {
          rules: [{ required: false, message: "请上传程序源码文件!" }],
        },
        zipFile: {
          rules: [{ required: false, message: "请上传zip格式的附件!" }],
        },
        videoFile: {
          rules: [{ required: false, message: "请上传mp4格式的视频!" }],
        },
      },
    };
  },
  created() {},
  methods: {
    open(myEvent) {
      this.visible = true;
      this.form.resetFields()
      this.eventInfo = myEvent;
      console.log(myEvent);
      if (myEvent.worksVOS && myEvent.worksVOS.length > 0) {
        let workInfo = myEvent.worksVOS[0];
        console.log(workInfo);
        this.$nextTick(() => {
          this.form.setFieldsValue(
            pick(workInfo, "workName", "workDesc", "workFile", "agreeFile", "zipFile", "videoFile")
          );
        });
      }
    },
    handleOk() {
      let that = this;
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          values.eventId = this.eventInfo.eventId;
          values.eventCategory = this.eventInfo.myEventCategory;
          if (this.eventInfo.worksVOS && this.eventInfo.worksVOS.length > 0) {
            values.id = this.eventInfo.worksVOS[0].workId;
          }
          postAction("/teaching/teachingWorkScore/submitWork", values)
            .then((res) => {
              if (res.success) {
                that.visible = false;
                that.$success({
                  title: "作品提交成功",
                  content: (
                    <div>
                      <p>如需修改作品，可在活动结束前再次提交。</p>
                    </div>
                  ),
                });
                that.$emit("ok");
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style>
</style>